import React from 'react';
import { useTranslation } from 'react-i18next';
import FullInfoField from 'components/FullInfoField/FullInfoField';

interface IProps {
	generateQrInstantly: boolean;
}

export const GenerateQrInstantlyField: React.FC<IProps> = ({ generateQrInstantly }) => {
	const { t } = useTranslation('form');
	const inputValue = generateQrInstantly ? t('yes') : t('no');

	return (
		<FullInfoField
			label="bankSettingsGenerateQrInstantlyLabel"
			value={inputValue}
			prefixIcon="asCheckbox"
			prefixIconName={generateQrInstantly ? 'checkMark' : 'crossMark'}
			prefixIconIsChecked={generateQrInstantly}
		/>
	);
};
